<div class="search-bar-container">
  <div class="search-bar-input-container">
    <input type="text" #input class="search-bar-input" autocomplete="off" placeholder="{{ placeholder | translate }}" matInput>
    <!-- <mat-icon matSuffix>search</mat-icon> -->
  </div>
</div>
